const AboutData = [

  {
    para: "Hello, my name is Vladimir Momiroski, I am 30 years old, I was born in Tetovo, I'm currently living in Skopje."
  },
  {
    para: " My interests have always been related to computers, as a child playing video games and today everything that is connected to programming. In addition to computers, i want to read and find out about various topics that interest me.",
  },
  {
    para: "2 years ago I decided to take a step forward in programming and completed a year-long boot camp in Brainster. During my education, i became more and more involved in coding, creating and solving problems."
  },
  {
    para: "I'm excited to make the leap and continue refining my skills with the right company."
  }
];


export default AboutData;
